import { styled, ThemeableStack } from 'tamagui';

export const Center = styled(ThemeableStack, {
  name: 'Center',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,

  variants: {
    vertical: {
      true: {
        justifyContent: 'center'
      }
    },

    horizontal: {
      true: {
        alignItems: 'center'
      }
    }
  } as const,

  defaultVariants: {
    vertical: true,
    horizontal: true
  }
});
